<template>

	<anchor-container>
		<img src="@/components/AppHeader/img/logo-il.svg" class="logo2" />

		<section class="video-section">
			<live-to-learn />
		</section>
		<anchor-content el="section" anchor="home-tour" title="Company Tour">
			<company-tour />
		</anchor-content>
		<FooterCTA>
			<template slot="headline">Explore StudySync's Award-Winning Products</template>
			<template slot="cta">
				<btn><router-link :to="{name: 'productsEla'}">StudySync ELA</router-link></btn>
				<btn><router-link :to="{name: 'productsSyncblasts'}">SyncBlasts</router-link></btn>
			</template>
		</FooterCTA>
		<footer class="legal-footer mhe-footer">
			<p>If you are a McGraw Hill StudySync user, please <a href="https://content.studysync.com/support/05/StudySyncMcGrawPartnershipFAQ.pdf">click here</a> to receive support on the below questions and more—FAQ​, Tech or platform support​, Requests for more materials, Requests for training​, Questions/concerns about your StudySync product, My StudySync subscriptions are about to expire. I want to renew, and I need help!​</p>
		</footer>
		<footer class="legal-footer">
			<span>© 2024 BookheadEd Learning, LLC.</span>
			<router-link :to="{name: 'legalPrivacy'}">Privacy Policy</router-link>
			<router-link :to="{name: 'legalTerms'}">Terms of Use</router-link>
		</footer>

	</anchor-container>

</template>

<script>

	import CompanyTour from '@/components/CompanyTour'
	import LiveToLearn from '@/components/LiveToLearn'
	import FooterCTA from '@/components/FooterCTA'
	import { AnchorContainer, AnchorContent } from "@/components/AnchorNav"

	export default {
		name: 'homepage',
		routeConfig: {
			path: '/'
		},
		metaInfo () {
			return this.$generateMetaInfo({
				title: `StudySync`,
				description: `StudySync is an award-winning educational publisher, developing products that leverage forward-thinking designs and technology to engage students while providing teachers and administrators with a relevant, easy-to-use platform that delivers adaptable, dynamic educational solutions.`,
				image: 'https://www.studysync.com/static/homepage1.jpg'
			})
		},
		components: { CompanyTour, LiveToLearn, FooterCTA, AnchorContainer, AnchorContent }
	}

</script>

<style lang="scss" scoped>

	@import "media";

	section {
		display:flex; overflow:hidden;
		@include media(large) {
			min-height:100vh;
		}
	}

	.video-section {
		min-height:100vh; overflow:hidden;
	}

	.legal-footer {
		background:#fff; padding:3rem; display:flex; flex-direction:row; justify-content:center; align-items:center; margin:0 auto;
	}
	.legal-footer > * {
		margin:0 1rem;
	}
	.mhe-footer {
		color: white;
		background: #FDB913;
	}
	.logo2 {
		position: absolute;
		top: calc(3.5em + 40px);
		left: 2.5em;
		width: 7em;
		height: auto;
		z-index: 1;
	}

</style>



// WEBPACK FOOTER //
// src/routes/homepage/index.vue